import { createContext } from "react";

import type { Size } from "~/tools/size";
import { useRequiredContext } from "~/tools/use-required-context";

const StageSizeContext = createContext<null | Size>(null);

export const useStageSize = (): Size =>
	useRequiredContext(StageSizeContext, {
		providerName: "Stage",
	});

export const StageContextProvider = StageSizeContext.Provider;
